import { BACKEND_API_URL } from '../constants';

/**
 * Default timeout for content blocker detection (in milliseconds)
 */
const DEFAULT_TIMEOUT_IN_MS = 3000; // 3 seconds

/**
 * Attempts to detect if a content blocker is enabled by trying to fetch a
 * known resource that might be blocked by ad blockers or content blockers.
 *
 * @param timeout - The timeout in milliseconds before considering the request blocked
 * @returns A promise that resolves to true if a content blocker is detected, false otherwise
 */
export async function detectContentBlocker(
  timeout = DEFAULT_TIMEOUT_IN_MS,
): Promise<boolean> {
  const controller = new AbortController();
  const { signal } = controller;
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  try {
    await fetch(BACKEND_API_URL, {
      method: 'HEAD',
      mode: 'no-cors',
      signal,
    });
    clearTimeout(timeoutId);
    return false;
  } catch (e) {
    return true;
  }
}
